const projects = [
  {
    id: 'disha',
    name: 'Project Disha',
    image: '/disha/hero.webp',
    description: 'A field guide for highly contextualized responses to early hysterectomies among India’s sugarcane harvesters',
  },
  {
    id: 'habitat2100',
    name: 'Habitat2100',
    image: 'habitat2100/hero.webp',
    description: 'An interactive window into the future of species habitats under climate change',
  },
  {
    id: 'rooted_in_place',
    name: 'Rooted In Place',
    image: '/rooted_in_place/hero.webp',
    description: 'An exploration of how 3D-printed scaffolds and plant roots can co-create the built environment',
  },
  // {
  //   id: 'heart_hat',
  //   name: 'Heart Hat',
  //   image: 'https://placehold.co/600x400/fff700/000?text=Cards',
  // },
];

export default projects; 